export default __webpack_public_path__ + "static/media/arrowDownMap.057f1771.svg";